import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Check for session_id in hash before React Router initializes
// This prevents auth redirects from stripping the hash
const hash = window.location.hash;
if (hash && hash.includes('session_id=')) {
  // Store the session_id temporarily so AuthCallback can retrieve it
  const sessionId = hash.split('session_id=')[1]?.split('&')[0];
  if (sessionId) {
    sessionStorage.setItem('pending_session_id', sessionId);
    console.log('Auth callback detected, storing session_id');
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
